<div #panel class="absolute -top-3 left-full z-10 pt-3 pr-3 pb-3 pl-2">
  <div class="border-default bg-elevated max-w-70 min-w-46 rounded-md border p-1 shadow-md">
    @for (option of options(); track trackMenuOptionByLabelAndIndex($index, option)) {
      <div
        class="relative"
        (mouseenter)="showSubMenu($index, option)"
        (mouseleave)="hideSubMenu()">
        <div
          class="flex items-center gap-2.25 rounded-sm px-2 py-1.5 text-[13px] leading-snug font-medium whitespace-nowrap transition-colors"
          [class]="itemClasses(option)"
          [class.bg-interactive]="hasSubOptions(option) && openSubMenuIndex() === $index"
          [attr.aria-expanded]="
            hasSubOptions(option) ? openSubMenuIndex() === $index : null
          "
          [attr.aria-disabled]="option.disabled || null"
          (click)="onOptionClick(option)"
          (keydown)="onOptionClick(option)">
          @if (showIcons()) {
            <span
              class="flex w-4 shrink-0 items-center justify-center text-sm leading-none"
              [class]="iconClasses(option)">
              @if (option.icon) {
                <i [class]="option.icon"></i>
              }
            </span>
          }
          <span class="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
            {{ option.label }}
            @if (option.hint) {
              <span
                class="text-text-tertiary block max-w-56 pt-0.5 text-[11.5px] leading-snug font-normal whitespace-normal">
                {{ option.hint }}
              </span>
            }
          </span>
          @if (option.meta) {
            <span
              class="ml-auto shrink-0 pl-2 text-[11px] font-normal"
              [class]="option.disabled ? 'text-text-tertiary' : 'text-text-secondary'"
              >{{ option.meta }}</span
            >
          }
          @if (hasSubOptions(option)) {
            <span class="text-text-tertiary ml-0.5 shrink-0 text-[13px]">
              <i class="ph-bold ph-caret-right"></i>
            </span>
          }
        </div>

        @if (hasSubOptions(option) && openSubMenuIndex() === $index) {
          <app-context-menu-submenu
            [options]="option.subOptions!"
            [showIcons]="showIcons()"
            (optionClicked)="optionClicked.emit($event)" />
        }
      </div>
    }
  </div>
</div>
